import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wpcm-custom-amt-box-container" }
const _hoisted_2 = {
  key: 0,
  class: "wpcm-custm-amt-box"
}
const _hoisted_3 = {
  key: 0,
  class: "wpcm-symbl-prefix"
}
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wpcm-custm-amt-before-title" }, [
      _createCommentVNode(" <slot name=\"before_title\"></slot> "),
      _createCommentVNode(" <h3 v-if=\"title\" class=\"wpcm-custm-amt-title\">{{ title }}</h3> ")
    ], -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "before_box"),
      ($props.custom_amount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            ($props.symbol)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.getSymbol()), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.amount) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateAmount($event))),
              onKeypress: $setup.isNumber,
              placeholder: 
            $props.strings
              ? $props.strings.donation_amount
              : 'Custom Amount'
          
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
              [
                _vModelText,
                $setup.store.amount,
                void 0,
                { number: true }
              ]
            ]),
            _renderSlot(_ctx.$slots, "in_box")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}